import axios from 'axios'
import Config from '@/config'
import store from '@/store/index'
import router from '@/router/index'
import { Notification } from 'element-ui'

const service = axios.create({
  baseURL: Config.base_url, // api 的 base_url
  timeout: Config.timeout, // 请求超时时间
  withCredentials: true
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (config.headers['Content-Type'] === undefined) {
      config.headers['Content-Type'] = 'application/json'
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error).then(r => {
      Notification.error({
        title: r.message
      })
    })
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.data.status
    if (code < 200 || code > 300) {
      if (code === 401) {
        store.dispatch('LogOut').then(() => {
          if (router.app.$route.path !== '/login') {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          }
        })
      }
      Notification.error({
        title: response.data.msg
      })
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(response.data.msg)
    } else {
      return response.data
    }
  },
  error => {
    console.log(error.response)
    let code = error.response.status

    if (error.toString().indexOf('Error: timeout') !== -1) {
      Notification.error({
        title: '网络请求超时',
        duration: 2500
      })
      return Promise.reject(error)
    }
    if (error.toString().indexOf('Error: Network Error') !== -1) {
      Notification.error({
        title: '网络请求错误',
        duration: 2500
      })
      return Promise.reject(error)
    }

    if (code === 401) {
      Notification.error({
        duration: 2500,
        title: '登录已过期。'
      })
      store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    } else if (code === 403) {
      Notification.error({
        title: '错误403',
        duration: 2500
      })
    } else {
      const errorMsg = error.response.data
      if (errorMsg !== undefined) {
        Notification.error({
          title: errorMsg,
          duration: 2500
        })
      }
    }
    return Promise.reject(error)
  }
)
export default service
